import { Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useRef } from 'react'

const HierSuggestion = (props) => {
    const data = props.hierSuggestion?.length > 0 ? props.hierSuggestion : null
    const divRef = useRef(null)

    const handleClick = agentId => {
        props.setOpenHierSuggestion(false)
        props?.handleClick(agentId)
    }

    useEffect(() => {
        props.setOpenHierSuggestion(false)
        if (data?.length > 0 && props.hierLevel > 0) {
            props.setOpenHierSuggestion(true)

            if (divRef.current) {
                divRef.current.scrollTo({
                    top: 0,
                    behavior: "smooth",
                }); 
            }
        }
    }, [props.hierLevel, props.hierSuggestion])

    return (
        <>
            <div className='absolute bottom-0 w-full translate-y-full'>
                <Transition
                    as={Fragment}
                    show={props.openHierSuggestion}
                    enter='transition ease-linear duration-300 transform'
                    enterFrom='-translate-y-full'
                    enterTo='translate-y-0'
                    leave='transition ease-linear duration-300 transform'
                    leaveFrom='translate-y-0'
                    leaveTo='-translate-y-full'
                >
                    <div className='shadow w-full bg-white rounded-b-[10px] overflow-hidden pb-4'>
                        <div ref={ divRef } className='h-[185px] w-full flex flex-wrap gap-4 overflow-scroll p-4 pb-1'>
                            {data?.map((agent, index) => (
                                <div onClick={() => handleClick(agent._id)} key={index} className='rounded-[10px] shadow w-[167px] h-[167px] p-2 bg-white flex-shrink-0 cursor-pointer transition hover:scale-[1.03]'>
                                    <div className='flex-center mb-2'>
                                        <div className='rounded-full flex items-center justify-center w-16 h-16 shadow-sm cursor-pointer overflow-hidden'>
                                            <img
                                                src={agent.UserProfileImage ?? "https://iprofstore.blob.core.windows.net/general/agentDefault.png"}
                                                alt={agent?.UserName}
                                            />
                                        </div>
                                        <div className='mt-1'>
                                            <p className='font-semibold text-gray-one leading-[1.15] text-sm text-center'>{agent?.UserName}</p>
                                        </div>
                                        <div className='badge-wrapper'>
                                            {agent.UserBranchName && <span className="badge bg-info-light">{agent.UserBranchName}</span>}
                                            {agent.UserGroupName && <span className="badge bg-info-light">{agent.UserGroupName}</span>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Transition>
            </div>
        </>
    )
}

export default HierSuggestion